<template>
  <div class="login">
    <div class="title">用户登录中心</div>
    <div class="teb">账户密码登录</div>
    <!--  表单部分  -->
    <div class="form">
      <el-form ref="form" :rules="rules" :model="form" @submit.native.prevent>
        <div class="form-input">
          <el-form-item class="form-item" :required="true">
            <el-input placeholder="账号" v-model="account"></el-input>
          </el-form-item>
        </div>
        <div class="form-input">
          <el-form-item class="form-item" :required="true">
            <el-input type="password" placeholder="密码" v-model="password"></el-input>
          </el-form-item>
        </div>
        <div class="form-input">
          <div style="display: flex">
            <el-form-item class="form-item" :required="true">
              <el-input placeholder="验证码" v-model="verifyCode.value"></el-input>
            </el-form-item>
            <img style="height: 40px; margin-left: 1rem" :src="imgVerifyCode" @click="getVerifyCode">
          </div>
        </div>
        <el-form-item>
          <el-button type="primary" native-type="submit" @click="enter('form')">登录</el-button>
          <el-button type="primary" @click="register()">注册</el-button>
        </el-form-item>
      </el-form>
    </div>
  </div>
</template>
<script>

import Axios from 'axios'
import md5 from 'js-md5'
import { Message } from 'element-ui'

const Base64 = require('js-base64').Base64
export default {
  name: 'Login',
  data () {
    return {
      redirect: '',
      form: {
        pdk: ''
      },
      account: '',
      password: '',
      verifyCode: {
      },
      imgVerifyCode: `${process.env.VUE_APP_LOADING_IMG}`,
      rules: {
        tagIds: [
          { type: 'array', required: true, message: '请选择', trigger: ['change'] }
        ]
      }
    }
  },
  mounted () {
    this.getVerifyCode()
  },
  watch: {
    $route: {
      handler (route) {
        this.redirect = (route.query && route.query.redirect) || '/web/userCenter/#/Usercenter'
      },
      immediate: true
    }
  },
  methods: {
    enter (formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.submit()
        } else {
          return false
        }
      })
    },
    getVerifyCode () {
      this.$set(this.verifyCode, 'value', '')
      Axios.get(`${process.env.VUE_APP_SERVER_URL}/ucenter/user/front/getVerifyCode`).then((response) => {
        const res = response.data
        if (res.status !== 200) {
          Message({
            message: res.message,
            type: 'warning'
          })
          return
        }
        this.imgVerifyCode = 'data:img/png;base64,' + res.data.value
        this.verifyCode.key = res.data.key
      })
    },
    register () {
      this.$router.push({ path: '/register' })
    },
    submit () {
      if (!this.account) {
        Message({
          message: '请输入账号',
          type: 'error'
        })
        return
      }
      if (!this.password) {
        Message({
          message: '请输入密码',
          type: 'error'
        })
        return
      }
      if (!this.verifyCode.value) {
        Message({
          message: '请输入验证码',
          type: 'error'
        })
        return
      }
      const timestamp = new Date().getTime()
      const account = this.account
      let pdk = this.password
      pdk = md5(account + pdk)
      pdk = md5(pdk + timestamp)
      const loginKv = {
        account: this.account,
        pdk: pdk,
        timestamp: timestamp,
        verifyCode: this.verifyCode
      }
      const body = JSON.stringify(loginKv)
      pdk = Base64.encode(body)
      Axios.get(`${process.env.VUE_APP_SERVER_URL}/ucenter/user/login`, {
        params: { pdk: pdk }
      }).then((response) => {
        const data = response.data
        if (data.status !== 200) {
          Message({
            message: data.message,
            type: 'warning'
          })
          this.getVerifyCode()
          return
        }
        const res = response.data
        res.data.user.account = this.account
        window.openBjStore.loginSuccess(res.data)
        const routerPath = this.redirect === '/404' || this.redirect === '/401' ? '/web/userCenter/#/Usercenter' : this.redirect
        console.log('routerPath=========>', routerPath)
        window.location.href = routerPath
      }).catch(() => {
        this.getVerifyCode()
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.login {
  width: 1200px;
  min-height: calc(100vh - 416px);
  margin: 0 auto;
  text-align: center;

  .title {
    font-size: 28px;
    color: #d43c33;
    margin-top: 50px;
  }

  .teb {
    margin-top: 40px;
    font-size: 16px;
    color: #d43c33;
  }

  .forget {
    margin-top: 40px;
    font-size: 14px;
    color: #d43c33;
    cursor: pointer;
  }

  .form {
    width: 300px;
    margin: 20px auto;
  }

  .form-input {
    margin-bottom: 10px;
  }
}
</style>
